<!--
 * @Author: zhaoyang
 * @Date: 2024-02-25 11:57:21
 * @Last Modified by: xiaodongyu
 * @Last Modified time: 2024-02-29 20:02:54
-->

<template>
    <div class="container product">
        <div class="block-img">
            <div class="small-title">
                匿名組合契約型
            </div>
            <div class="title">
                インドネシア・マイクロファイナンス第1号
            </div>
            <div class="text-wrap">
                <div
                    v-for="item in product"
                    :key="item"
                    class="text"
                >
                    {{ item }}
                </div>
            </div>
            <div class="desc">
                <span class="desc-text">
                    <span class="text1">目標利回り</span>
                    <span class="text2">７％</span>
                    <span class="text1">/年</span>
                </span>
                <span class="desc-text second">
                    <span class="text1">運用期間</span>
                    <span class="text2">１８０</span>
                    <span class="text1">日</span>
                </span>
            </div>
        </div>

        <div class="wrap">
            <div
                v-for="item in descList"
                :key="item.label"
                class="wrap-item"
            >
                <div class="left">
                    {{ item.label }}
                </div>
                <div class="right">
                    {{ item.text }}
                </div>
            </div>
        </div>

        <div class="agreement-wrap">
            <div class="agree-title">
                <span class="title-left">以下の同意事項を</span><span class="title-right">お読みいただき、同意してください。</span>
            </div>
            <div class="agree-desc">
                契約締結前交付書面,匿名組合契約書を全て読み、出資に伴うリスクや出資契約の内容を全て理解し自らの意思および判断に基づき下記金額の出資を申し込みます。
            </div>
            <div
                v-for="(item, idx) in agreementList"
                :key="idx"
                class="check"
            >
                <img
                    class="check-icon"
                    :src="item.isCheck ? Select : NoSelect"
                    alt=""
                    @click="onCheck(idx, item)"
                >
                <span class="check-text">{{ pdfDisplayNameMap[item.text] }}</span>
                <span
                    class="check-link"
                    @click="handleRead(idx)"
                >読む</span>
            </div>
        </div>

        <div class="money-wrap">
            <div class="title">
                出資申込金額
            </div>

            <div class="sub-title">
                （残り募集金額を超える額は申し込めません）
            </div>

            <div class="sub-title">
                （３万円以上１万円単位）
            </div>

            <div class="input-wrap">
                <input
                    v-model="money"
                    type="number"
                    max="1500"
                    min="3"
                    placeholder="〇〇〇〇"
                    class="money-input"
                    :class="{error: noLess}"
                >
                <span class="big-tip">万円</span>
            </div>

            <div
                v-if="showTip"
                class="input-tip"
            >
                ファンド募集上限額とお客樣の出資上限を超えた金額は申し込めません
            </div>

            <div class="money-tip">
                <div
                    v-for="item in tipList"
                    :key="item.label"
                    class="money-item"
                >
                    <div class="left">
                        {{ item.label }}
                    </div>
                    <div class="right">
                        {{ item.text }}
                    </div>
                </div>
            </div>
            <div
                v-if="finance.kyc"
                class="tip-desc"
            >
                「東京&nbsp;&nbsp;太郎様の出資申込可能額は2000万円以下です。」
            </div>
        </div>

        <div class="btn-wrap">
            <div
                class="btn"
                :class="{active: canSubmit}"
                @click="handleSubmit"
            >
                申込
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

import {pdfDisplayNameMap} from 'instacash/common/constant';

import NoSelect from '../register/step1/img/no-select.svg';
import Select from '../register/step1/img/select.svg';

export default {
    name: 'FinanceProduct',

    data() {
        return {
            hasTouch: false,
            money: '',
            NoSelect,
            Select,
            pdfDisplayNameMap,
            product: [
                '目標利回り：７％／年',
                '運用期間：１８０日',
                'ファンド名：インドネシア・マイクロファイナンス第1号（匿名組合契約型）'
            ],
            agreementList: [
                {
                    showCheck: false,
                    isCheck: false,
                    text: 'contract-before'
                },
                {
                    showCheck: false,
                    isCheck: false,
                    text: 'fund-risk'
                },
                {
                    showCheck: false,
                    isCheck: false,
                    text: 'anonymous'
                }
            ],
            tipList: [
                {
                    label: '申込状況',
                    text: '１５００万円（５０％）'
                },
                {
                    label: '残り募集金額',
                    text: '１５００万円'
                },
                {
                    label: '残り募集日数',
                    text: '３日'
                }
            ],
            descList: [
                {
                    label: 'ファンド名',
                    text: 'インドネシア・マイクロファイナンス第1号（匿名組合契約型）'
                },
                {
                    label: '営業者',
                    text: 'インスタキャッシュ株式会社'
                },
                {
                    label: '募集総額',
                    text: '3000万円（上限）'
                },
                {
                    label: '募集最低額',
                    text: '1800万円'
                },
                {
                    label: '最低申込額',
                    text: '3万円、追加単位1万円'
                },
                {
                    label: '募集期間',
                    text: '2020年1月〇日～同年1月○○日'
                },
                {
                    label: '運用期間',
                    text: '180日'
                },
                {
                    label: '中途解約',
                    text: '無'
                },
                {
                    label: '運用通貨',
                    text: 'インドネシア・ルピア'
                },
                {
                    label: '出資金払込',
                    text: '円貨'
                },
                {
                    label: '出資金返還及び分配金交付',
                    text: '円貨'
                },
                {
                    label: '目標利回り',
                    text: '年７％（運用期間利回り3.452％）'
                }
            ]
        };
    },

    computed: {
        ...mapState(['finance']),

        canSubmit() {
            const {money, showTip, agreementList, noLess} = this;

            return !noLess && money && !showTip && agreementList.every(item => item.isCheck);
        },

        noLess() {
            const {hasTouch} = this;
            if (!hasTouch && !this.money) {
                return false;
            }

            return this.money < 3 || this.money.toString().includes('.');
        },

        showTip() {
            return this.money > 1500;
        }
    },

    watch: {
        money() {
            this.hasTouch = true;
        }
    },

    methods: {
        handleSubmit() {
            if (!this.canSubmit) return;

            const {kyc, currentStepRouteName} = this.finance;
            if (!kyc) {
                this.$router.push({
                    name: currentStepRouteName || 'RegisterStep1-1'
                });

                return;
            }

            this.$store.commit('finance/updateFinance', {
                bought: true
            });
            this.$router.push({
                name: 'ProductRecord'
            });
        },

        onCheck(idx, item) {
            if (!item.showCheck) return;
            this.agreementList[idx].isCheck = !this.agreementList[idx].isCheck;
        },

        handleRead(idx) {
            this.agreementList[idx].showCheck = true;
            window.open(`/static/pdf/${this.agreementList[idx].text}.pdf`);
        }
    }
};
</script>

<style lang="scss" scoped>
.product {
    display: flex;
    flex-direction: column;
    align-items: center;

    .block-img {
        box-sizing: border-box;
        padding: 0.4rem 0.6rem 1.24rem;
        width: 12.5rem;
        display: flex;
        flex-direction: column;
        position: relative;
        border-radius: 0.16rem;
        background-image: url("./img/bg-s.png");
        background-size: 100% 100%;

        .small-title {
            margin-bottom: 0.16rem;
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #cacaca;
        }

        .title {
            font-family: Noto serif JP;
            font-size: 0.32rem;
            font-weight: 700;
            line-height: 0.42rem;
            color: #fff;
        }

        .text-wrap {
            margin-top: 0.16rem;
            width: 6.3rem;

            .text {
                font-family: Noto Sans JP;
                font-size: 0.14rem;
                font-weight: 400;
                line-height: 0.22rem;
                color: #fff;
            }
        }

        .desc {
            width: 6.8rem;
            box-sizing: border-box;
            border-radius: 0.12rem;
            padding: 0.1rem 0.42rem 0.16rem;
            background-color: #f0f0f0;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 50%);

            .desc-text {
                .text1 {
                    font-family: Noto Sans JP;
                    font-size: 0.16rem;
                    font-weight: 400;
                    line-height: 0.26rem;
                    color: #5f5b5a;
                }

                .text2 {
                    font-family: Noto serif JP;
                    font-size: 0.48rem;
                    font-weight: 700;
                    line-height: 0.62rem;
                    color: #32302f;
                }
            }

            .second {
                margin-left: 0.9rem;
            }
        }
    }

    .wrap {
        margin-top: 1.42rem;
        width: 6.8rem;

        .wrap-item {
            display: flex;
            margin-top: 0.12rem;

            .left {
                width: 1.75rem;
                font-family: Noto Sans JP;
                font-size: 0.14rem;
                font-weight: 700;
                line-height: 0.22rem;
                color: #32302f;
            }

            .right {
                flex: 1;
                margin-left: 0.4rem;
                font-family: Noto Sans JP;
                font-size: 0.14rem;
                font-weight: 400;
                line-height: 0.22rem;
                color: #5f5b5a;
            }
        }
    }

    .agreement-wrap {
        width: 6.8rem;
        margin-top: 0.95rem;

        .agree-title {
            margin-bottom: 0.2rem;

            .title-left {
                font-family: Noto Sans JP;
                font-size: 0.16rem;
                font-weight: 400;
                line-height: 0.26rem;
            }

            .title-right {
                font-family: Noto Sans JP;
                font-size: 0.16rem;
                font-weight: 700;
                line-height: 0.26rem;
            }
        }

        .agree-desc {
            margin-top: 0.08rem;
            margin-bottom: 0.32rem;
            font-family: Noto Sans JP;
            font-size: 0.12rem;
            font-weight: 400;
            line-height: 0.19rem;
            color: #828180;
        }

        .check {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 0.12rem;
            cursor: pointer;

            .check-icon {
                margin-right: 0.08rem;
                width: 0.18rem;
                height: 0.18rem;
            }

            .check-text {
                font-family: Noto Sans JP;
                font-size: 0.12rem;
                font-weight: 400;
                line-height: 0.19rem;
                color: $c-02;
            }

            .check-link {
                font-family: Noto Sans JP;
                font-size: 0.12rem;
                font-weight: 700;
                line-height: 0.19rem;
                color: $green-03;
                margin-left: 0.08rem;
            }
        }
    }

    .btn-wrap {
        margin-top: 0.4rem;
        width: 6.8rem;

        .btn {
            border-radius: 0.12rem;
            width: 3rem;
            height: 0.52rem;
            background-color: $c-06;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Noto Sans JP;
            font-size: 0.16rem;
            font-weight: 700;
            line-height: 1;
        }

        .active {
            color: $c-09;
            background-color: $yellow-02;
        }
    }

    .money-wrap {
        border-radius: 0.16rem;
        width: 6.8rem;
        margin-top: 0.57rem;
        box-sizing: border-box;
        padding: 0.28rem 0.4rem 0.5rem;
        background-color: #f1f0f0;

        .title {
            color: #000;
            font-family: Noto serif JP;
            font-size: 0.2rem;
            font-weight: 700;
            line-height: 0.26rem;
        }

        .sub-title {
            margin-top: 0.09rem;
            color: #4c4948;
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
        }

        .input-wrap {
            margin-top: 0.18rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .money-input {
                box-sizing: border-box;
                width: 5.04rem;
                height: 0.79rem;
                border-radius: 0.16rem;
                padding-left: 0.24rem;
                padding-right: 0.24rem;
                border: 1px solid #cacaca;
                font-family: Noto serif JP;
                font-size: 0.4rem;
                font-weight: 700;
                line-height: 0.52rem;
                color: #32302f;
                outline: none;

                &::placeholder {
                    color: #a7a7a7;
                }
            }

            .big-tip {
                font-family: Noto serif JP;
                font-size: 0.4rem;
                font-weight: 700;
                line-height: 1;
                color: #828180;
            }
        }

        .error {
            border-color: #f66c70;

            &:focus {
                border-color: #f66c70;
            }
        }

        .input-tip {
            margin-top: 0.16rem;
            font-family: Noto Sans JP;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.22rem;
            color: #f66c70;
        }

        .money-tip {
            margin-top: 0.28rem;

            .money-item {
                display: flex;
                margin-top: 0.12rem;

                .left {
                    width: 0.9rem;
                    font-family: Noto Sans JP;
                    font-size: 0.14rem;
                    font-weight: 700;
                    line-height: 0.22rem;
                    color: #32302f;
                }

                .right {
                    margin-left: 0.4rem;
                    font-family: Noto Sans JP;
                    font-size: 0.14rem;
                    font-weight: 400;
                    line-height: 0.22rem;
                    color: #5f5b5a;
                }
            }
        }

        .tip-desc {
            margin-top: 0.16rem;
        }
    }
}
</style>
